import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in
  const token = localStorage.getItem("gysumo_token");

  useEffect(() => {
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {
        localStorage.removeItem("gysumo_token");
        setUser(false);
      });
  }, [token]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gysumo_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("gysumo_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function ProtectedRoute() {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
        Laden…
      </div>
    );
  if (!user) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return <Outlet />;
}
